import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × COURBET: Material realism translated to data
// Granular textures, earthy tones, dense grids
export function VasarelyCourbetMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Earthy material background */}
      <rect x="0" y="0" width="794" height="1123" fill="#2C2416" opacity="0.9" />

      <g transform="translate(397 540)">
        {/* Dense material grid (realistic data texture) */}
        {Array.from({ length: 25 }).map((_, i) =>
          Array.from({ length: 35 }).map((_, j) => {
            const x = (i - 12) * 26;
            const y = (j - 17) * 23;
            const grain = Math.random() * 0.3;
            const earthTone = Math.random() > 0.5;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 10}
                y={y - 10}
                width="20"
                height="20"
                fill={earthTone ? "#8B7355" : brand.violet}
                opacity={0.25 + grain}
              />
            );
          })
        )}

        {/* Granular optical pattern */}
        {Array.from({ length: 200 }).map((_, i) => {
          const angle = Math.random() * Math.PI * 2;
          const r = Math.random() * 280;
          const x = Math.cos(angle) * r;
          const y = Math.sin(angle) * r;
          
          return (
            <circle
              key={i}
              cx={x}
              cy={y}
              r={2 + Math.random() * 3}
              fill={Math.random() > 0.5 ? brand.amber : "#CD853F"}
              opacity={0.3 + Math.random() * 0.2}
            />
          );
        })}

        {/* Material strata (geological layers of data) */}
        {Array.from({ length: 12 }).map((_, i) => {
          const y = -240 + i * 40;
          const width = 500 - Math.abs(i - 6) * 30;
          const irregularity = Math.sin(i * 0.5) * 20;
          
          return (
            <rect
              key={i}
              x={-width / 2 + irregularity}
              y={y}
              width={width}
              height="30"
              fill="#8B7355"
              opacity={0.15 + (i % 3) * 0.05}
            />
          );
        })}

        {/* Solid geometric forms (material presence) */}
        {[
          { x: -140, y: -100, w: 100, h: 80 },
          { x: 80, y: -120, w: 120, h: 90 },
          { x: -100, y: 100, w: 90, h: 100 },
          { x: 120, y: 120, w: 110, h: 85 },
        ].map((block, i) => (
          <g key={i}>
            <rect
              x={block.x - block.w / 2}
              y={block.y - block.h / 2}
              width={block.w}
              height={block.h}
              fill="#8B7355"
              opacity="0.3"
            />
            <rect
              x={block.x - block.w / 2}
              y={block.y - block.h / 2}
              width={block.w}
              height={block.h}
              fill="none"
              stroke={brand.amber}
              strokeWidth="2"
              opacity="0.5"
            />
          </g>
        ))}

        {/* Transparency markers (material honesty) */}
        {Array.from({ length: 8 }).map((_, i) => {
          const r = 60 + i * 30;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={i % 2 === 0 ? brand.amber : "#CD853F"}
              strokeWidth="2"
              opacity={0.25 - i * 0.02}
            />
          );
        })}

        {/* Material evidence nodes */}
        {[0, 60, 120, 180, 240, 300].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 200;
          return (
            <circle
              key={angle}
              cx={Math.cos(rad) * r}
              cy={Math.sin(rad) * r}
              r="8"
              fill={brand.amber}
              opacity="0.6"
            />
          );
        })}

        {/* Structural honesty frame */}
        <rect x="-260" y="-240" width="520" height="480" fill="none" stroke="#8B7355" strokeWidth="3" opacity="0.4" />
      </g>

      {/* Realist inscription */}
      <text x="397" y="1000" textAnchor="middle" fontFamily="serif" fontSize="11" fill={brand.amber} opacity="0.5">
        réalisme matériel
      </text>
    </g>
  );
}
